<template>
    <div id="manager-root" class="layui-layout layui-layout-admin">
        <div class="layui-header header header-demo">
            <div class="layui-logo" style="color: #eee;font-size: 20px">{{oemLogoTxt}}</div>
            <!-- 头部区域（可配合layui已有的水平导航） -->
            <ul class="layui-nav layui-layout-left">
                <li v-for="(it, index) in menu" :key="index" :class="{'selected-me layui-nav-item':selectedMenu.title==it.title,'layui-nav-item':selectedMenu.title!=it.title}" ><a href="javascript:void(0)" @click="selectMain(it.title)">{{it.title}}</a></li>
            </ul>
            <ul class="layui-nav layui-layout-right">
                <li class="layui-nav-item">
                    <a href="javascript:;">
                        <img src="http://t.cn/RCzsdCq" class="layui-nav-img">
                        {{uinfo.username}}
                    </a>
                    <!--<dl class="layui-nav-child">-->
                    <!--<dd><a href="">基本资料</a></dd>-->
                    <!--<dd><a href="">安全设置</a></dd>-->
                    <!--</dl>-->
                </li>
                <li class="layui-nav-item"><a href="javascript:void(0)" @click="logout()">退了</a></li>
            </ul>
        </div>

        <div class="layui-side layui-bg-black">
            <div class="layui-side-scroll">
                <!-- 左侧导航区域（可配合layui已有的垂直导航） -->
                <el-menu
                default-active="1"
                class="el-menu-vertical"
                @select="select"
                background-color="#393D49"
                text-color="#fff"
                :unique-opened="true"
                active-text-color="#ffd04b">
                <el-menu-item  :index="indexPath" key="0">
                    <i class="el-icon-location-outline"></i>
                    <span>首页</span>
                </el-menu-item>
                <template v-for="m in selectedMenu.children">
                    <el-submenu v-if="m.children!==undefined&&m.children.length>0" :title="m.title" :key="m.navId" :index="m.title+'_'+m.navId">
                        <template slot="title">
                            <i class="el-icon-caret-right"></i>
                            <span>{{m.title}}</span>
                            <span class="dotMark" v-if="m.dotIs">●</span>
                            <span class="dealNum" v-else-if="m.dealNum">{{m.dealNum}}</span>
                        </template>
                        <el-menu-item v-for="c in m.children" style="padding-left: 60px" :title="c.title" :key="c.navId" :index="c.href">
                            ● {{c.title}}
                            <span class="dotMark" v-if="c.dotIs">●</span>
                            <span class="dealNum" v-else-if="c.dealNum">{{c.dealNum}}</span>
                        </el-menu-item>
                    </el-submenu>
                    <el-menu-item v-else-if="m.href!==undefined" :index="m.href" :key="m.navId" :title="m.title">
                        <i class="el-icon-menu"></i>
                        <span slot="title">
                            {{m.title}}
                            <span class="dotMark" v-if="m.dotIs">●</span>
                            <span class="dealNum" v-else-if="m.dealNum">{{m.dealNum}}</span>
                        </span>
                    </el-menu-item>
                </template>
                </el-menu>
            </div>
        </div>
        <div class="layui-body">
            <el-tabs
                v-model="activeIndex"
                type="card"
                closable
                @tab-click="tabClick"
                v-if="options.length"
                class="contain-tabs-el"
                @tab-remove="tabRemove">
                <el-tab-pane
                :key="item.name"
                v-for="item in options"
                :label="item.title"
                :name="item.route"
                :url="item.url">
                <iframe v-if="item.url!==undefined&&item.url!=='undefined'" style="width: 100%;border: 0;height: 100%;" align="middle"
                        marginwidth="0" marginheight="0" :id="item.id" @onload="setIframeHeight(item.id)"
                        :src="item.url"></iframe>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div class="site-tree-mobile layui-hide" @click="showmenu()">
            <i class="layui-icon">&#xe602;</i>
        </div>
        <div class="site-mobile-shade" @click="unshowmenu()"></div>
    </div>
</template>

<script>
  import Vue from 'vue'
  import ElementUI from 'element-ui';
  import 'element-ui/lib/theme-chalk/index.css';
  import {ajax,logout,getUnreadData} from "../../data/service";

  import * as permission from '../../data/permission';

  Vue.use(ElementUI);

  import * as config from '../../config/const';


  export default {
    data(){
      return {
        menu:[],
        selectedMenu:{},
        index: 0,
        uinfo:{},
        tab_selected:'首页',
        wailian:1,
        activeDate:1,
        indexUrl:'',
        indexPath:'',
        oemLogoTxt:'管理后台',
        unreadList: [],
        unreadMap: {}
      }
    },
    mixins:[ajax],
    created(){
      this.getLoginUser().then((res) => {
        this.uinfo=res;
        this.oemLogoTxt=res.oemLogoTxt;
        if (isNaN(res.appPanelId)){
          this.indexUrl=res.appPanelId;
        }else{
          this.indexUrl="/apages/admin?id="+res.appPanelId;
        }
        this.indexPath="/admin/index/"+res.systemFlag;
        //加工menus如果menus中出现无子级且href有空的情况
        for(var m in this.uinfo.menus){
          this.fixMenu(this.uinfo.menus[m]);
        }
        this.menu=this.uinfo.menus;
        this.selectedMenu=this.menu[0];
        this.tab_selected=this.$route.name;
        if (this.$store.state.options.length<2) {
          this.$store.commit('add_tabs', {route: this.indexPath, name: 'home',title:'首页',url:this.indexUrl,id:"iframe_0"});
          this.$store.commit('set_active_index', this.$route.path);
          if (this.$route.path !== this.indexPath) {//首页
            var id=this.$route.path.replace("/admin/frame/","");
            this.$store.commit('add_tabs', {route: this.$route.path, name: this.$route.name+this.wailian,title:decodeURIComponent(this.$route.query.title),url:decodeURIComponent(this.$route.query.path),id:"iframe_"+id});
            this.$store.commit('set_active_index',this.$route.path);
            this.wailian++;
          }
        }
        this.getUnreadData()
      });
      window.addEventListener('message', (e) => {
        let data = e.data

        if(data.type == 1){ //重新获取值
          // console.info(1)
          // this.unreadMap = {
          //   202: true
          // }
          // this.convertData()
          this.getUnreadData()
        }
      })
    },
    computed: {
      options(){
        return this.$store.state.options;
      },
      activeIndex: {
        get () {
          return this.$store.state.activeIndex;
        },
        set (val) {
          this.$store.commit('set_active_index', val);
        }
      }
    },
    methods:{
      getUnreadData(){
        this.doajax(getUnreadData, {}, res => {
          this.unreadList = res.data
          let unreadMap = {}
          this.unreadList.forEach(item => {
            unreadMap[item.navId] = item.dotIs ? item.dotIs : item.dealNum ? item.dealNum : ""
          })
          this.unreadMap = unreadMap
          // console.info(this.unreadMap)
          this.convertData()
        })
      },

      convertData(){
        let menus = JSON.parse(JSON.stringify(this.uinfo.menus))
        menus.forEach(menu => {
          this.dg(menu.children)
        });
        this.menu = menus
        this.selectedMenu = this.menu[this.index]
      },

      dg(data){
        data.forEach(item => {
          // console.info(item)
          if(this.unreadMap[item.navId]){
            if(typeof this.unreadMap[item.navId] == 'boolean'){
              item.dotIs = true
            }else if(typeof this.unreadMap[item.navId] == 'number'){
              item.dealNum = this.unreadMap[item.navId]
            }
          }
          if(item.children){
            this.dg(item.children)
          }
        })

      },

      fixMenu(menu){
        if(menu.children!==undefined&&menu.children.length>0){
          for(var m in menu.children){
            this.fixMenu(menu.children[m])
          }
        }else if(menu.permission!==undefined&&menu.href===undefined&&permission.MAP[menu.permission]!==undefined){
            menu.href=permission.MAP[menu.permission]
        }
      },
      selectMain(title){
        for(var i in this.menu){
          var m=this.menu[i];
          if(m.title==title){
            this.index = i
            this.selectedMenu=m;
          }
        }
      },
      select(index,path,selObj){

        // console.log("index:"+index);
        // console.log("path:"+path);
        // console.log("this.$route.path:"+this.$route.path);


        var id=selObj.$options._parentVnode.key;
         if (this.$route.query.path!== undefined&&decodeURIComponent(this.$route.query.path).endsWith(index.substring(1))) {
           // console.log("this.$route.query.path:"+this.$route.query.path);
          if(!document.getElementById("iframe_"+id).contentWindow.location.href.endsWith(decodeURIComponent(this.$route.query.path))){//链接被跳过的情况
            // console.log("变");
            document.getElementById("iframe_"+id).contentWindow.location.href=decodeURIComponent(this.$route.query.path);
          }else{
            // console.log("不变");
            document.getElementById("iframe_"+id).contentWindow.location.reload(true);
            }
        }else if(index=== this.indexPath){
           if(this.$route.path.endsWith(index.substring(1))){//刷新首页
             if (!document.getElementById("iframe_0").contentWindow.location.href.endsWith(this.indexUrl)) {
               document.getElementById("iframe_0").contentWindow.location.href=this.indexUrl;
             }else{
               document.getElementById("iframe_0").contentWindow.location.reload(true);
             }
           }else{
             this.$router.push(this.indexPath);
           }
         }else{
           if(index.indexOf('https://admin.20lz.com/')>=0){//如果带主域名的，直接原地刷新
             window.open(index);
           }else{
             this.$router.push({path:"/admin/frame/"+id,query:{title:encodeURIComponent(selObj.$attrs.title),path:encodeURIComponent(index)}});
           }
        }

        document.getElementsByTagName('body')[0].classList.remove("site-mobile");
      },
      showmenu(){
        document.getElementsByTagName('body')[0].classList.add("site-mobile");
      },
      unshowmenu(){
        document.getElementsByTagName('body')[0].classList.remove("site-mobile");
      },
      tabClick (tab) {// tab切换时，动态的切换路由
          if (tab.$options.propsData.name ===  this.indexPath) {
              this.$router.push({path: this.indexPath});
          }else if (this.$route.path.endsWith(tab.$options.propsData.name.substring(1))) {
            //需要刷新一下
              var id=this.$route.path.replace("/admin/frame/","");
            document.getElementById("iframe_"+id).contentWindow.location.reload(true);
        }else if(tab.$options.propsData.name !==  this.indexPath){
              this.$router.push({path:tab.$options.propsData.name,query:{title:encodeURIComponent(tab.$options.propsData.label),path:encodeURIComponent(tab.$attrs.url)}});
          }

        if(tab.$options.propsData.name ===  this.indexPath&&this.$route.path.endsWith(tab.$options.propsData.name.substring(1))){//刷新首页
          document.getElementById("iframe_0").contentWindow.location.reload(true);
        }
      },
      tabRemove (targetName) {
        // 首页不可删除
        if(targetName ===  this.indexPath) {
          return;
        }
        this.$store.commit('delete_tabs', targetName);
        if (this.activeIndex === targetName) {
          // 设置当前激活的路由
          if (this.options && this.options.length >= 1) {
            var option=this.options[this.options.length-1];
            this.$router.push({path: option.route,query:{title:encodeURIComponent(option.title),path:encodeURIComponent(option.url)}});
          } else {
            this.$router.push({path: this.indexPath});
          }
        }
      },
      logout(){
        this.doajax(logout,{},(resp) => {
          this.removeUser();
          for (let option of this.options ) {
            this.$store.commit('delete_tabs', option.route);
          }
          top.location.href=config.AUTH_FILTER.admin.loginUrl;
        });
      },
        setIframeHeight(iframeId) {
          CONSOLE.INFO(123456)
          var iframe=document.getElementById(iframeId);
          console.info(1234567)
          if (iframe) {
                var iframeWin = iframe.contentWindow || iframe.contentDocument.parentWindow;
                if (iframeWin.document.body) {
                    iframe.height = iframeWin.document.documentElement.scrollHeight || iframeWin.document.body.scrollHeight;
                }
            }
        }
    },
    watch: {
      '$route'(to) {
        if (to.path === this.indexPath) {
          this.$store.commit('set_active_index', this.indexPath);
          return;
        }
        let flag = false;
        for (let option of this.options ) {
            if (option.route === to.path) {
              flag = true;
              this.$store.commit('set_active_index', to.path);
              break
            }
        }
        if (!flag) {
            var id=to.path.replace("/admin/frame/","");
            this.$store.commit('add_tabs', {route: to.path, name: to.name+this.wailian,title:decodeURIComponent(to.query.title),url:decodeURIComponent(this.$route.query.path),id:"iframe_"+id});
            this.$store.commit('set_active_index', to.path);
            this.wailian++;
        }
      }
    }
  }
</script>
<style>
  @import "../../style/layui/css/layui.css";
  @import "../../style/layui/css/global.css";
  .el-menu-vertical{
    width: 200px
  }
  .selected-me a{
    color: rgb(255, 208, 75) !important;
  }
  .contain-tabs-el{
    height: 100%;
  }
  .contain-tabs-el .el-tabs__content{
    height: calc(100% - 56px);
  }
  .contain-tabs-el .el-tabs__content .el-tab-pane{
    height: 100%;
  }

  .el-menu li .dotMark,
  .el-menu li .dealNum{display: inline-block; height: 16px; line-height: 12px; color: #F94040; margin-left: 5px;}
  .el-menu li .dealNum{width: auto; height: 20px; line-height: 20px; text-align: center; padding: 0 14px; border-radius: 10px; background: #2E313C;}
</style>



// WEBPACK FOOTER //
// src/pages/pcs/manage.vue